export const state = {
  courses: [],
  loadingCourses: true
}

